import get from 'typesaurus/get';
import { useEffect, useState } from '../adaptor';
export default function useGet(collectionOrRef, maybeId) {
    let collection;
    let id;
    if (collectionOrRef && collectionOrRef.__type__ === 'collection') {
        collection = collectionOrRef;
        id = maybeId;
    }
    else {
        const ref = collectionOrRef;
        collection = ref === null || ref === void 0 ? void 0 : ref.collection;
        id = ref === null || ref === void 0 ? void 0 : ref.id;
    }
    const [result, setResult] = useState(undefined);
    const [error, setError] = useState(undefined);
    const loading = result === undefined && !error;
    const deps = [JSON.stringify(collection), id];
    useEffect(() => {
        if (result)
            setResult(undefined);
        if (collection && id)
            get(collection, id).then(setResult).catch(setError);
    }, deps);
    return [result, { loading, error }];
}
//# sourceMappingURL=index.js.map